import formatDateTime from "./formatDateTime";

const getDuration = (duration, format = "MMM DD, YYYY HH:mm") =>
  duration
    ? `${formatDateTime(duration.fromDate, format)} - ${formatDateTime(duration.toDate, format)}`
    : "";

export default getDuration;
